/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Step2title1Inputs */

const he_extension_step2title1 = /** @type {(inputs: Extension_Step2title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גלוש ב-KSP`)
};

const en_extension_step2title1 = /** @type {(inputs: Extension_Step2title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse KSP`)
};

/**
* | output |
* | --- |
* | "Browse KSP" |
*
* @param {Extension_Step2title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_step2title1 = /** @type {((inputs?: Extension_Step2title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Step2title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_step2title1(inputs)
	return en_extension_step2title1(inputs)
});
export { extension_step2title1 as "extension_step2Title" }